export const MUMBLETHEME = 'MUMBLETHEME';
